@for( message of messages(); track $index) {
@if( message.show ){
<div class="chat__message-row" [ngClass]="{
    'chat__message-row--no-animation': !isUser(message.role),
    'chat__message-row--proactive': message.isProactive
}">

  @if(dataChat.icon() && !isUser(message.role) && !message.isProactive){
  <div class="chat__thumbnail-wrapper">
    <div class="chat__thumbnail-new">
      <img class="chat__thumbnail" [src]="dataChat.icon()" alt="icon">
    </div>
  </div>
  }

  <div class="chat__message-wrapper" [ngClass]="{
          'chat__message-wrapper--user': isUser(message.role),
          'chat__message-wrapper--no-icon': (!dataChat.icon() || message.isProactive) && !isUser(message.role)
        }">

    <div class="chat__message" [ngClass]="{
            'chat__message--user': isUser(message.role),
            'chat__message--has-error': message.danger,
            'chat__message--proactive': message.isProactive
            }" (click)="message.isProactive ? onProactiveClick(message) : null">

      @if(isUser(message.role) && message.imageUrl){
        <img [src]="message.imageUrl" />
      }

      <div class="notranslate">
        <markdown class="markdown" linkIntercept [data]="message.content | translate"></markdown>
        <!-- Renderizar Widget de Clima si existe -->
        @if(message.weatherData) {
        <weather-widget [data]="message.weatherData" />
        }
      </div>
    </div>

    <!-- Link previews: burbuja separada entre respuesta y tags -->
    @if(!isUser(message.role)) {
    @for(url of extractUrls(message.content); track url; let i = $index) {
    <link-preview [url]="url" [colorVariant]="i" />
    }
    }

    <!-- Burbujas proactivas inline: solo se muestran DESPUÉS de que el streaming termine -->
    <!-- TODO: check isStreaming scroll ----- @if(message.proactiveChildren && message.proactiveChildren.length > 0 && !isStreaming()) { -->
     @if(message.proactiveChildren && message.proactiveChildren.length > 0) {
    @for(tip of message.proactiveChildren; track tip.id) {
    <div class="chat__message chat__message--proactive"
         (click)="onProactiveClick(tip)">
      <div class="notranslate">
        <markdown class="markdown" linkIntercept [data]="tip.content | translate"></markdown>
      </div>
    </div>
    }
    }

    @if(message.tags && message.tags.length > 0){
    <div class="chat__interests-container">
      @for(tag of message.tags; track tag){
      <span class="chat__interest-chip">{{tag}}</span>
      }
    </div>
    }

    @if(!isUser(message.role) && !message.danger && !message.isProactive){
    <div class="action-icons-container" [ngClass]="{'disabled' : isStreaming()}">
      <icon-clipboard (click)="copyToClipboard($event)"></icon-clipboard>
      @if(!checkPlayingOnDemand(message.id)){
      @if(isLoadingAudioById() === message.id){
      <ci-icon name="loader-debounce" scale="1x"></ci-icon>
      } @else {
      <icon-sound 
        [disabled]="isPlayingChatbot()"
        [class.disabled]="isPlayingChatbot()"
        (click)="playAudio($event, errAudio)" 
        [attr.data-tracking-id]="message.id">
      </icon-sound>
      }
      } @else {
      <icon-music-stop (click)="stopAudio()"></icon-music-stop>
      }

      <div class="feedback-icons">
        <button class="feedback-btn positive" [class.active]="message.feedback === 'positive'"
          (click)="sendFeedback(message, 'positive')" title="Me gusta">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3">
            </path>
          </svg>
        </button>
        <button class="feedback-btn negative" [class.active]="message.feedback === 'negative'"
          (click)="sendFeedback(message, 'negative')" title="No me gusta">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zM17 2h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3">
            </path>
          </svg>
        </button>
      </div>
      <span class="copy-text">{{'Texto copiado' | translate }}</span>
      <span #errAudio class="error-audio">{{'Error al reproducir audio' | translate }}</span>
    </div>
    }
  </div>
</div>
}
}